/**
 * Rotulos de data da operacao. A agenda e a fila mostram o mesmo periodo, e
 * por isso escrevem igual: por extenso no desktop, curto no celular.
 */

const long = new Intl.DateTimeFormat('pt-BR', { dateStyle: 'full' });
const weekday = new Intl.DateTimeFormat('pt-BR', { weekday: 'long' });
const numeric = new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: '2-digit' });

/** "Terca-feira, 4 de agosto de 2026". */
export function longDayLabel(date: Date): string {
  return long.format(date);
}

/**
 * "Terca, 04/08" - o dia da semana sem o "-feira" e a data em numeros, que e o
 * que cabe entre as setas na tela estreita.
 */
export function shortDayLabel(date: Date): string {
  const day = weekday.format(date).replace('-feira', '');

  return `${day.charAt(0).toUpperCase()}${day.slice(1)}, ${numeric.format(date)}`;
}
